import Swal from "sweetalert2";

export const showSwalLoader = (title = 'Please wait…') =>
  Swal.fire({
    title,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => Swal.showLoading(), // animated spinner
    backdrop: true,
  });

export const hideSwalLoader = () => Swal.close();